/* JS for lib/actions.html */

let sharedTwitter = false;
let sharedEmail = false;
let sharedObjectId = null;
let sharedObjectType = null;

function saveShareMethod(csrf, id, type, url, shareMethod) {
    if (shareMethod === 'twitter') {
        if (!sharedTwitter) {
            $.ajaxSetup({
                beforeSend(xhr) {
                    xhr.setRequestHeader('X-CSRFToken', csrf);
                },
            });
            $.ajax({
                method: 'POST',
                url,
                data: {
                    shareMethod,
                    object_id: id,
                    content_type: type,
                },
                csrfmiddlewaretoken: csrf,
            }).done(() => {
                sharedTwitter = true;
            });
        }
    } else if (shareMethod === 'email') {
        if (!sharedEmail || sharedObjectId !== id || sharedObjectType !== type) {
            $.ajaxSetup({
                beforeSend(xhr) {
                    xhr.setRequestHeader('X-CSRFToken', csrf);
                },
            });
            $.ajax({
                method: 'POST',
                url,
                data: {
                    shareMethod,
                    object_id: id,
                    content_type: type,
                },
                csrfmiddlewaretoken: csrf,
            }).done(() => {
                sharedEmail = true;
                sharedObjectId = id;
                sharedObjectType = type;
            });
        }
    }
}

function submitContactMe(form) {
    $.ajax({
        data: form.serialize(),
        type: form.attr('method'),
        url: form.attr('action'),
        success(response) {
            if ($.trim($('.more-info-content').html()).length < 1) {
                const contactMeButton = $('.contact-me-btn');
                if (contactMeButton.is('input')) {
                    contactMeButton.val(response.message);
                } else {
                    contactMeButton.text(response.message);
                }
                contactMeButton.prop('disabled', true);
            } else {
                $('#ajax-response').html(`<p>${response.message}</p>`);
                $('#ajax-response').delay(5000).fadeOut(2000);
            }
        },
    });
}

function moreInfo(url) {
    // Called in actions.html ~L60 Used to submit contact me on content item display
    if ($.trim($('.more-info-content').html()).length > 0) {
        $('#hidden-contact-me-btn').click(() => {
            $('.more-info-show').show();
        });
    }

    $('#hidden-contact-me').submit((event) => {
        event.preventDefault();
        submitContactMe($(event.currentTarget));
        if (url) {
            window.openInNewTab(url);
        }
        return false;
    });
}

$(document).ready(() => {
    /**
     * Handles API request for bookmarking/saving/removing video from playlist.
     * On successful action, displays notification alert with message received in response.
     * @param {jQuery event} event
     */

    const handleSaveVideoToPlaylistRequest = (event) => {
        event.preventDefault();
        const $this = $(event.currentTarget);

        const url = $this.attr('href');
        const csrftoken = Cookies.get('csrftoken');

        $.ajax({
            url,
            type: 'POST',
            headers: { 'X-CSRFToken': csrftoken },
            success: (response) => {
                const alertMessage = `<div data-alert="alert" class="fade in alert ${
                    response.add_class || 'alert-success'
                }"><button type="button" class="close" data-dismiss="alert">x</button> ${
                    response.message || 'Updated successfully!'
                }</div>`;
                $('#alerts').append(alertMessage);

                // If new url provided, update it
                if (response.url) {
                    $this.attr('href', response.url);
                }

                // If label text should be updated
                if (response.update_text) {
                    const $textLabel = $('span[id$="text"]', $this);
                    if ($textLabel) {
                        $textLabel.html(response.update_text);
                    }
                }

                // displays notification
                $('.alert').addClass('show');

                // removes notification after 4 seconds
                window.setTimeout(() => {
                    $('.alert')
                        .fadeTo(500, 0)
                        .slideUp(500, () => {
                            $('.alert').remove();
                        });
                }, 4000);

                // Mixpanel tracking
                const context = window.__VUMEDI_VIDEO_DETAIL_CONTEXT__;
                if (context?.videoId) {
                    if ($this.attr('id') === 'bookmark') {
                        const favorited = response.update_text === 'Remove from Favorites';
                        window.vumedi?.mixpanel?.track('VideoFavorited', {
                            video_id: context.videoId,
                            video_slug: context.videoSlug,
                            channel_id: context.channelId,
                            favorited,
                            template_version: context.templateVersion,
                        });
                    } else if ($this.hasClass('playlist-add-remove') && response.created) {
                        window.vumedi?.mixpanel?.track('VideoAddedToPlaylist', {
                            video_id: context.videoId,
                            video_slug: context.videoSlug,
                            channel_id: context.channelId,
                            playlist_id: parseInt($this.data('playlist-id'), 10) || null,
                            template_version: context.templateVersion,
                        });
                    }
                }
            },
            error: (request) => {
                if (request.status === 401) {
                    const data = request.responseJSON;
                    window.location.href = data.redirect_url;
                }
            },
        });
    };

    /**
     * Assign event handler for bookmarking and adding video to playlist
     */
    $('#bookmark, .playlist-add-remove').on('click', handleSaveVideoToPlaylistRequest);

    $('#new-playlist-form form.modal-form').on('submit', function () {
        const context = window.__VUMEDI_VIDEO_DETAIL_CONTEXT__;
        if (!context?.videoId) return;

        window.vumedi?.mixpanel?.track('VideoAddedToPlaylist', {
            video_id: context.videoId,
            video_slug: context.videoSlug,
            channel_id: context.channelId,
            playlist_id: null,
            template_version: context.templateVersion,
        });
    });

    const trackVideoShared = (shareMethod, extraProps) => {
        const context = window.__VUMEDI_VIDEO_DETAIL_CONTEXT__;
        if (!context?.videoId) return;

        window.vumedi?.mixpanel?.track('VideoShared', {
            share_method: shareMethod,
            video_id: context.videoId,
            video_slug: context.videoSlug,
            channel_id: context.channelId,
            template_version: context.templateVersion,
            ...extraProps,
        });
    };

    $('.js_shareDropdown').one('shown.bs.dropdown', () => {
        window.twttr = ((d, s, id) => {
            const fjs = d.getElementsByTagName(s)[0];
            const t = window.twttr || {};
            if (d.getElementById(id)) return t;
            const js = d.createElement(s);
            js.id = id;
            js.src = 'https://platform.twitter.com/widgets.js';
            fjs.parentNode.insertBefore(js, fjs);

            t._e = [];
            t.ready = (f) => {
                t._e.push(f);
            };
            return t;
        })(document, 'script', 'twitter-wjs');

        window.twttr.ready((twttr) => {
            twttr.events.bind('click', () => {
                trackVideoShared('X');
            });
        });
    });

    $('.js_linkedinShare').on('click', () => {
        trackVideoShared('LinkedIn');
    });

    $("button[type='submit']", "div[id$='share-modal']").click((event) => {
        const $modal = $(event.currentTarget).closest("div[id$='share-modal']");
        const data = $modal.data();
        saveShareMethod(data.csrf_token, data.object_id, data.content_type, data.url, 'email');
        const recipientCount = $modal
            .find('textarea[name="to"]')
            .val()
            .split('\n')
            .filter((line) => line.trim() !== '').length;
        trackVideoShared('email', { recipient_count: recipientCount });
    });

    window.addEventListener('industryvideo:moreinfo', (event) => {
        moreInfo(event.detail.url);
    });
    window.addEventListener('video_with_actions_enabled_fields:moreinfo', (event) => {
        moreInfo(event.detail.url);
    });
});

$(document).on('click', '.contactme-submit', (e) => {
    const form = $(e.currentTarget).parents('form');
    submitContactMe(form);
});
